import { ColorPallet } from "../utils/colorPallet";

export const styles = {
    lastTable: {
        mt: 1,
        p: 1,
        width: "100%",
      },
      thirdBox: {
        display: "flex",
        fontSize: "14px",
        fontWeight: 400,
        flexDirection: "column",
        "@media screen and (max-width: 480px)": {
                        fontSize: "12px",
        },
      },
      secondBox: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column",
        sm: "row",
        },
      },
      mainBox: {
        margin: 3,
        backgroundColor: ColorPallet?.bgcolor,
        marginTop: "10px",
        padding: "10px",
        borderRadius: "5px",
        "@media screen and (max-width: 1024px)": {
                    padding: "7px",
        margin: 2,
        "@media screen and (max-width: 768px)": {
                    padding: "5px",
        margin: 1,
        },
        "@media screen and (max-width: 480px)": {
                    padding: "3px",
        margin: 1,
        },
        },
      },
      textFieldLength: {
        width: "350px",
      },
      textFieldSearchContainer: {
        px: 3,
        display: "flex",
        flexDirection: { xs: "column",
        sm: "row",
        gap: 2,
        justifyContent: "space-between",
        },
      },
      containerHeading: {
        p: 3,
        fontSize: "24px",
        fontWeight: "bold",
      },
      mainContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "75vh",
        // Set height to full viewport height,
      },
      editBatch: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        cursor: "pointer",
      },
      expireBox: {
        display: "flex",
        alignItems: "center",
        gap: 1,
      },
      span_med: {
        fontSize: "10px",
        position: "relative",
        bottom: 9,
        right: 1,
      },
}